import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getBankAccounts(id) {
    return Repository.get(`${resource}/bank_accounts/${id}`)
  },
  getListOfBankAccounts(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/bank_accounts?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createBankAccount(payload) {
    return Repository.post(`${resource}/bank_accounts`, payload)
  },
  deleteBankAccount(id) {
    return Repository.delete(`${resource}/bank_accounts/${id}`)
  },
  updateIncoterms(id, payload) {
    return Repository.put(`${resource}/incoterms/${id}`, payload)
  }
};
